import React from 'react';
import { Link } from 'react-router-dom';

// Strings and { t, href } parts. Internal paths use the router. External links open in a new tab.
export function RichText({ value }) {
  const parts = Array.isArray(value) ? value : [value];
  return parts.map((part, i) => {
    if (part == null || part === '') return null;
    if (typeof part === 'string') return <React.Fragment key={i}>{part}</React.Fragment>;
    const href = part.href || '';
    if (href.startsWith('/')) return <Link key={i} to={href}>{part.t}</Link>;
    return (
      <a key={i} href={href} target="_blank" rel="noopener noreferrer">{part.t}</a>
    );
  });
}

export function Blocks({ blocks }) {
  if (!blocks) return null;
  return blocks.map((block, i) => {
    if (block.type === 'h2') return <h2 key={i} id={block.id}>{block.text}</h2>;
    if (block.type === 'ul') {
      return (
        <ul key={i} className="area-list">
          {block.items.map((item, j) => (
            <li key={j}><RichText value={item} /></li>
          ))}
        </ul>
      );
    }
    if (block.type === 'note') {
      return (
        <div key={i} className="area-note">
          <RichText value={block.text} />
        </div>
      );
    }
    return <p key={i}><RichText value={block.text} /></p>;
  });
}
